import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/common_v2/userComponents/Avatar';
import { Link } from 'react-router-dom';
import { urlConstructor, urlMap } from 'routes/urlMap';
import Box from '../box';
import {
  Container, ContentContainer, WorkerNameText, Content
} from './styled';

const WorkerLayout = ({
  avatarSize, avatarUrl, content, fullName, id, workerLink, referrer
}) => (
  <Container>
    <Box alignItems="center">
      <div
        style={{ width: avatarSize, height: avatarSize, marginRight: '8px' }}
      >
        <Avatar
          flex={1}
          avatarUrl={avatarUrl}
          name={fullName}
          size={avatarSize}
        />
      </div>
      <ContentContainer>
        <WorkerNameText>
          <Link
            to={{
              pathname: workerLink || urlConstructor(urlMap.WORKERS, { id }),
              state: {
                from: referrer
              }
            }}
            data-test-id={`job-row__worker-name--${id}`}
          >
            {fullName}
          </Link>
        </WorkerNameText>
        <Content>{content}</Content>
      </ContentContainer>
    </Box>
  </Container>
);

WorkerLayout.propTypes = {
  avatarSize: PropTypes.string,
  avatarUrl: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fullName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  workerLink: PropTypes.string,
  referrer: PropTypes.string
};

WorkerLayout.defaultProps = {
  avatarSize: '36px',
  content: undefined,
  workerLink: undefined,
  referrer: ''
};

export default WorkerLayout;
